import type { Action } from '../common/actions'
import { FileWasRemovedFromJob, FilesCopiedToAlbum, FilesCopiedToAlbumFailed } from '../job/actions'

import type { ConfirmableSelectionAction } from './actions'
import {
    FilesWereDeselected,
    FilesWereSelected,
    SelectionActionConfirmHandled,
    SelectionActionInitiated,
    SelectionCanceled,
} from './actions'

export type SelectedFilesState = {
    files: FileID[]
    selectionAction?: ConfirmableSelectionAction
}
const initialState: SelectedFilesState = { files: [] }

export const selectedFilesReducer = (
    state: SelectedFilesState = initialState,
    action: Action,
): SelectedFilesState => {
    if (FilesWereDeselected.match(action)) {
        const selectedFiles = new Set(state.files)
        action.payload.forEach((f) => selectedFiles.delete(f))
        return { ...state, files: Array.from(selectedFiles) }
    }

    if (FilesWereSelected.match(action)) {
        const selectedFiles = new Set(state.files)
        action.payload.forEach((f) => selectedFiles.add(f))
        return { ...state, files: Array.from(selectedFiles) }
    }

    if (FileWasRemovedFromJob.match(action)) {
        const selectedFiles = new Set(state.files)
        selectedFiles.delete(action.payload.fileID)
        return { ...state, files: Array.from(selectedFiles) }
    }

    if (SelectionActionInitiated.match(action)) {
        return { ...state, selectionAction: action.payload }
    }

    if (SelectionActionConfirmHandled.match(action)) {
        return { ...state, selectionAction: undefined }
    }

    if (FilesCopiedToAlbum.match(action) || FilesCopiedToAlbumFailed.match(action)) {
        const selectedFiles = new Set(state.files)
        action.payload.files.forEach((f) => selectedFiles.delete(f))
        return { ...state, files: Array.from(selectedFiles) }
    }

    if (SelectionCanceled.match(action)) {
        return { ...state, files: [] }
    }

    return state
}

export const selectedFilesReducerMapObj = {
    selectedFiles: selectedFilesReducer,
}

export type StateWithSelectedFiles = StateOfReducerMapObj<typeof selectedFilesReducerMapObj>
